/**
 * I hate email validation
 * 
 * matches RFC2822 standards.
 * 
 * @see https://fightingforalostcause.net/content/misc/2006/compare-email-regex.php
 */
const emailRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i

/**
 * Rule to check if a field is a valid email address
 */
export default {
    name     : 'email',
    validate : (value) => String(value).match(emailRegex) !== null,
    message  : field => `The field ${field} must be an email address`
}